import {NgModule} from '@angular/core';
import {PricingListRoutingModule} from './pricing-list-routing.module';

@NgModule({
  imports: [
    PricingListRoutingModule
  ]
})
export class PricingListModule {
}
